import Filters from './Filters'

class Category extends Filters {
	constructor (container, itemsContainer) {
		super(itemsContainer)
		this.container = container
		this.status = {}
		this.init()
	}

	init () {
		this.categoryElem = [...document.querySelectorAll('#venueCategory input')]
		this.addListeners()
	}

	addListeners () {
		this.categoryElem.forEach(input => {
			input.addEventListener('change', () => {
				this.status[input.value] = input.checked
				this.refactorValue()
			})
		})
	}

	refactorValue (notify = true) {
		const valueArr = []
		const keys = Object.keys(this.status)
		keys.forEach(key => {
			if (this.status[key]) {
				valueArr.push(key)
			}
		})
		this.set(valueArr, notify)
	}

	blockFilters () {
		this.categoryElem.forEach(input => {
			input.disabled = true
		})
	}

	unblockFilters () {
		this.categoryElem.forEach(input => {
			input.disabled = false
		})
	}

	setFilter (value, reset = false) {
		const toSet = value.split(',')
		this.categoryElem.forEach(input => {
			if (reset) {
				input.checked = false
				this.status[input.value] = false
				this.refactorValue(false)
			}
			toSet.forEach(newValue => {
				if (input.value == newValue) {
					input.checked = true
					this.status[input.value] = true
					this.refactorValue(false)
				}
			})
		})
	}
}

export default Category



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/filters/Category.js